import { usePermissions, useQueryParams } from 'hooks';
import ScheduleReminderType from 'types/enum/ScheduleReminderType';
import { QueryParam } from 'utils/constants/queryParam';
import { IPermissionCheckableMember } from 'utils/positionUtils';
import { IScheduleReminderDetails } from '../types/types';
function useSchedulingDataFilter() {
  const queryParams = useQueryParams();
  const { hasPermissionToManage } = usePermissions();

  function filter(reminders: IScheduleReminderDetails[]) {
    const currentMemberGroupId = queryParams.getParam(QueryParam.EMPLOYEE_GROUP_ID);
    const currentPositionId = queryParams.getParam(QueryParam.POSITION_ID);
    const currentProjectId = queryParams.getParam(QueryParam.PROJECT_ID);
    const currentProjectGroupId = queryParams.getParam(QueryParam.PROJECT_GROUP_ID);
    const currentColors = queryParams.getParam(QueryParam.COLORS);
    const type = queryParams.getParam(QueryParam.TYPE) as ScheduleReminderType | null;
    const colorList: string[] | null = currentColors ? currentColors.split(',') : null;

    return reminders.filter((reminder) => {
      if (type && reminder.type !== type) {
        return false;
      }

      if (currentProjectGroupId) {
        if (reminder.project?.depth === 1 && currentProjectGroupId !== reminder.project.projectGroupId) {
          return false;
        }

        if (
          reminder.project?.depth !== 1 &&
          currentProjectGroupId !==
            reminder.project?.ancestors?.find((ancestor) => ancestor.depth === 1)?.projectGroupId
        ) {
          return false;
        }
      }

      if (currentColors && !colorList?.some((color) => color.toLowerCase() === reminder.color?.toLowerCase())) {
        return false;
      }

      if (currentProjectId) {
        if (!reminder.project) {
          return false;
        }

        if (currentProjectId === reminder.project.id) {
          return true;
        }

        const ancestorIds = reminder.project?.ancestors?.map((ancestor) => ancestor.id);
        return !!ancestorIds?.includes(currentProjectId);
      }

      return reminder.links.some((link) => {
        if (currentPositionId && link.member?.positionId !== currentPositionId) {
          return false;
        }

        if (!hasPermissionToManage(link.member as unknown as IPermissionCheckableMember, 'viewSchedule')) {
          return false;
        }

        if (currentMemberGroupId && link.member!.memberGroupId !== currentMemberGroupId) {
          return false;
        }

        return true;
      });
    });
  }

  return filter;
}

export default useSchedulingDataFilter;
